<template>
  <div>
    <v-layout>
      <v-text-field  append-icon="search" :label="etiket" maxlength="50"  @click:append="dialogac()" :tabindex="tabdeger"
        v-model="val"  :hint=hint :readonly=readonly></v-text-field>
    </v-layout>
    <v-dialog scrollable="" v-model="dialog" max-width="550px">
      <v-card color="grey lighten-5">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text">Muhasebe Kodu Listesi</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field solo hide-details ref="ara" autofocus="" v-model="secilendeger" :label="this.$t('Search')"
            append-icon="search"></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-layout row="" wrap="">
            <div class="flex md12">
              <v-data-table :headers="headersservis" :loading="progress" :items="items" hide-actions
                class="elevation-1">
                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr @click="kabul(props.item.HesapKodu)" item>
                    <td class="text-xs-left">{{ props.item.HesapKodu }}</td>
                    <td class="text-xs-left">{{ props.item.HesapAdi }}</td>
                  </tr>
                </template>

              </v-data-table>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">
            {{$t("cancel_button")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    props: ["value", "tabdeger","etiket","readonly","hint"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    methods: {
      kayitgetir: kayitgetir,
      dialogac: dialogac,
      kabul: kabul,
      checkCode:checkCode,
    },
    data() {
      return {
        headersservis: [{
            text: this.$t('Code'),
            value: 'HesapKodu'
          },
          {
            text: this.$t('Description'),
            value: 'HesapAdi'
          }

        ],
        nextMuhasebe:false,
        progress: false,
       
        items:[],
        accountItems:{
          Code:'',
          CodeName:''
        },
        aranacakkelime: null,
        secilendeger: null,
        dialog: false,
        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {
      secilendeger(val) {
         val && this.kayitgetir(val)
      },
      dialog(val2) {
        if (!val2) return
        requestAnimationFrame(() => {
          this.$refs.ara.focus()
        })
      }

    },
  }

  function kabul(m) {
    this.val = m
    this.dialog = false
  }


  function dialogac() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.nextMuhasebe==false)
    {
       
      var params1 = {
      AccountingCode: null,
      AccountingName: null,
      AccountingSearch: null,
      CompanyCode: credentials.SirketKodu,
    }

    this.$http.post(auth.API_URL + 'api/Definitions/AccountingCodeList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body

      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-AccountingCodeList'
        this.snackbar = true
        this.progress = false

      } else {
        this.text1 = 'Service Unavailable-AccountingCodeList'
        this.snackbar = true
        this.progress = false
      }
    })
    }
   else
   {
  this.items=[];
  
    var params2 = {
          UserID: 0,
          CodeID: 0,
          CompanyID:credentials.MuhasebeSirketNo,
          Code: null,
          SearchText: '',
          BalanceShow: false,
        };
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeList",
          params2,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            for (let index = 0; index < response.body.length; index++) {
                  const element = response.body[index];
                  this.items.push({
                   
                   
                    ID: element.CodeID,
        SirketKodu: element.CompanyID,
        HesapKodu: element.Code,
        HesapAdi:element.CodeName,
        Title: element.Code + "-" + element.CodeName

                   
                    
                  });
                 
                }
            
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              
            } else {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              
            }
          }
        );
   }
    this.dialog = true
  }

  function beforeMount() {

    // var params = {}
    //     this.$http.post(auth.API_URL + 'api/Parameters/Get', params, {
    //       headers: {
    //         'Authorization': 'Bearer ' + auth.getAuthHeader()
    //       }
    //     }).then((response) => {
    //       this.nextMuhasebe = response.body.NextMuhasebe;

    //     }, (response) => {
    //       if (response.status === 0) {
    //         this.text = 'Parametre Service Unavailable'
    //         this.snackbar = true

    //       } else {
    //         this.text = 'Parametre Service Unavailable'
    //         this.snackbar = true

    //       }
    //     })
    //     console.log(this.nextMuhasebe);
  }

  function checkCode(){
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          AccountingCode: null,
          AccountingName: null,
          AccountingSearch: this.val,
          CompanyCode: credentials.SirketKodu,
        }

        this.$http.post(auth.API_URL + 'api/Definitions/AccountingCodeSearch', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if(response.body.length == 1){
            if(response.body[0].HesapKodu.trim() != this.val.trim()){
                this.val = '';
            }
          }else{
            this.val = '';
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-AccountingCodeList'
            this.snackbar = true
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable-AccountingCodeList'
            this.snackbar = true
            this.progress = false
          }
        })

  }

  function kayitgetir(y) {
    console.log('2')
    if (this.nextMuhasebe==false)
    {
      console.log('3')
      if (y != null) {

if (y.length > 0) {

  var credentials = JSON.parse(window.localStorage.getItem('credentials'));
  var params1 = {
    AccountingCode: null,
    AccountingName: null,
    AccountingSearch: y,
    CompanyCode: credentials.SirketKodu,
  }

  this.$http.post(auth.API_URL + 'api/Definitions/AccountingCodeSearch', params1, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    this.items = response.body

    this.progress = false
  }, (response) => {
    if (response.status === 0) {
      this.text1 = 'Service Unavailable-AccountingCodeList'
      this.snackbar = true
      this.progress = false

    } else {
      this.text1 = 'Service Unavailable-AccountingCodeList'
      this.snackbar = true
      this.progress = false
    }
  })
 
    
} 
else {
  console.log('4')
  this.items = []
  this.progress = false
}

} 
    }
   else
   {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.items=[];
  
    var params2 = {
          UserID: 0,
          CodeID: 0,
          CompanyID:credentials.MuhasebeSirketNo,
          Code: null,
          SearchText: y,
          BalanceShow: false,
        };
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeList",
          params2,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            for (let index = 0; index < response.body.length; index++) {
                  const element = response.body[index];
                  this.items.push({  
                    ID: element.CodeID,
        SirketKodu: element.CompanyID,
        HesapKodu: element.Code,
        HesapAdi:element.CodeName,
        Title: element.Code + "-" + element.CodeName
                  });
                }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              
            } else {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              
            }
          }
        );
   }
    
    
  }
</script>